export default __webpack_public_path__ + "f49c78d9ba1a35c294e626dc00c3138a.png";